import type { Translatable} from "@@/shared/translations/translation";
import { translation } from "@@/shared/translations/translation";
import z from "zod";

const buyableOrderItemStatusValues = [
    "delivered",
    "undelivered",
    "cancelled",
] as const;
const buyableOrderItemStatusValuesZodSchema = z.enum(
    buyableOrderItemStatusValues,
);
type BuyableOrderItemStatusValue = z.infer<
    typeof buyableOrderItemStatusValuesZodSchema
>;

const buyableOrderItemStatusZodSchema = z.array(
    z.object({
        index: z.number().min(0),
        value: buyableOrderItemStatusValuesZodSchema,
    }),
);

type BuyableOrderItemStatus = z.infer<typeof buyableOrderItemStatusZodSchema>;

const buyableOrderItemStatusTranslations: Record<
    BuyableOrderItemStatusValue,
    Translatable
> = {
    delivered: translation({
        sv: "Levererad",
        en: "Delivered",
    }),
    undelivered: translation({
        sv: "Ej levererad",
        en: "Undelivered",
    }),
    cancelled: translation({
        sv: "Avbokad",
        en: "Cancelled",
    }),
};

export {
    buyableOrderItemStatusTranslations,
    buyableOrderItemStatusValues,
    buyableOrderItemStatusValuesZodSchema,
    buyableOrderItemStatusZodSchema,
};
export type { BuyableOrderItemStatus, BuyableOrderItemStatusValue };
